import { ONBOARDING_CHOSEN_REASONS } from '@constants';
import { Form } from 'antd';

import { MaxHeightWrapper, StepWrapper } from '../../../styles';
import { TranslatedTitle } from '../components';

import { ReasonRadio } from '@/components/Onboarding';

export const ChosenReasons = () => {
  return (
    <StepWrapper>
      <TranslatedTitle i18nKey="CHOSEN_REASONS" />
      <MaxHeightWrapper>
        <Form.Item rules={[{ required: true, message: '' }]} name={['onBoarding', 'chosenReason']}>
          <ReasonRadio options={ONBOARDING_CHOSEN_REASONS} />
        </Form.Item>
      </MaxHeightWrapper>
    </StepWrapper>
  );
};
